import React, {useEffect, useState} from 'react';
import Columns from "./Columns";
import CardModal from "./modals/CardModal";
import {collection, onSnapshot, query} from "firebase/firestore";
import db from "../firebase";
const Board = () => {
  const [statuses, setStatuses] = useState([]);
  const getStatuses = () => {
	const statusesColRef = query(collection(db, "statuses"));
	onSnapshot(statusesColRef, (snapshot) => {
	  setStatuses(
		snapshot.docs.map((doc) => ({
		  id: doc.id,
		  ...doc.data(),
		}))
	  );
	});
  };


  useEffect(  () => {
	getStatuses();
  },[])

  return (
	<div className="shadow p-3 mb-5 bg-secondary-subtle" >
		<CardModal statuses={statuses}/>
	  <Columns statuses={statuses}/>
	</div>
  );
};
export default Board;
